export { default } from './P18PriceInfoWithoutImage';
